<mat-card appearance="outlined" class="col-md-12">
  <mat-card-header>
    <mat-card-title>
      <mat-icon>mail_outline</mat-icon>
      Outlook
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if (outlookAttendees.length==0) {
      <div class="no-data">There are currently no attendees for this Outlook event</div>
    }
    @if (outlookAttendees.length>0) {
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="outlook-attendee-subtitle"><mat-icon class="outlook-icon">person</mat-icon>Outlook Attendees</div>
          </div>
          <mat-list>
            @for (attendee of outlookAttendees; track attendee) {
              <mat-list-item>
                <div class="outlook-attendee"><div class="attendee-marker"></div>{{attendee.emailAddress.name}}</div>
              </mat-list-item>
            }
          </mat-list>
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>
